export type MaybeGetter<T, Arg = never> = T | ((arg: Arg) => T);
export type MaybeGetterValue<T> =
  T extends MaybeGetter<infer V, infer _Arg> ? V : never;

export function getValueOrReturnValue<T>(value: MaybeGetter<T>, arg?: never): T;
export function getValueOrReturnValue<T, Arg>(
  value: MaybeGetter<T, Arg>,
  arg: Arg,
): T;

export function getValueOrReturnValue<T, Arg>(
  value: MaybeGetter<T, Arg>,
  arg: Arg,
): T {
  return typeof value === "function" ? (value as (arg: Arg) => T)(arg) : value;
}
